// extracted by mini-css-extract-plugin
export var marginNegative = "_7j-5 _7j-3 _7j-1";
export var marginPositive = "_7j-4 _7j-3 _7j-1";
export var modalContent = "_7j-6";
export var samplesTable = "_7j-8";
export var samplesTableContainer = "_7j-7";
export var statBox = "_7j-a";
export var tableCell = "_7j-1";
export var tableCellCenter = "_7j-2 _7j-1";
export var tableCellRight = "_7j-3 _7j-1";
export var tableHeader = "_7j-0";
export var trackingNumber = "_7j-9";